import React, { useState } from 'react';
import { useShop } from '../../context/ShopContext';
import { defaultAnnouncements } from '../../data/products';
import { 
  Megaphone, 
  Plus, 
  Trash2, 
  Save, 
  RotateCcw, 
  TrendingUp, 
  Sparkles, 
  Check, 
  Eye
} from 'lucide-react';

export default function AdminAnnouncements() {
  const { announcementData, updateAnnouncements, liveGoldRates, addToast } = useShop();
  const [form, setForm] = useState({ ...announcementData });
  const [newItemText, setNewItemText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    updateAnnouncements(form);
  };

  const handleAddItem = (e) => {
    e.preventDefault();
    if (!newItemText.trim()) return;
    setForm((prev) => ({
      ...prev,
      items: [...prev.items, newItemText.trim()]
    }));
    setNewItemText('');
  };

  const handleRemoveItem = (index) => {
    setForm((prev) => ({
      ...prev,
      items: prev.items.filter((_, idx) => idx !== index)
    }));
  };

  const handleReset = () => {
    setForm(defaultAnnouncements);
    updateAnnouncements(defaultAnnouncements);
    addToast('Announcements reset to default notices', 'info');
  };

  return (
    <div style={{ maxWidth: '960px' }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        marginBottom: '2rem'
      }}>
        <div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: 'var(--gold-400)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.3rem' }}>
            <Sparkles size={13} /> Header Announcement CMS
          </div>
          <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#fff' }}>
            Top Ticker & <span className="text-gold-gradient">Live Announcement Ribbon</span>
          </h2>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
            Broadcast festive notices, shipping guarantees, and toggle live bullion rates across the top sticky header.
          </p>
        </div>

        <button
          type="button"
          onClick={handleReset}
          className="btn btn-glass btn-sm"
          style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem' }}
        >
          <RotateCcw size={14} />
          <span>Reset Defaults</span>
        </button>
      </div>

      {/* Live Preview of Ribbon */}
      <div style={{
        background: '#0d0d16',
        border: '1px solid var(--border-gold)',
        borderRadius: 'var(--radius-md)',
        padding: '1.2rem',
        marginBottom: '2rem'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.8rem', color: 'var(--gold-400)', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase' }}>
          <Eye size={15} /> Storefront Ribbon Preview
        </div>

        <div style={{
          backgroundColor: '#07070b',
          border: '1px solid rgba(212, 175, 55, 0.25)',
          borderRadius: 'var(--radius-sm)',
          padding: '0.6rem 1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '0.76rem',
          color: 'var(--gold-300)',
          overflow: 'hidden'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', overflow: 'hidden' }}>
            <span style={{
              background: 'var(--gold-gradient)',
              color: '#000',
              fontWeight: 800,
              fontSize: '0.65rem',
              padding: '0.15rem 0.45rem',
              borderRadius: '2px',
              textTransform: 'uppercase'
            }}>
              LIVE NOTICE
            </span>
            <span style={{ color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {form.items[0] || 'No announcement message set'}
            </span>
          </div>

          {form.showBullionTicker && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', flexShrink: 0, fontWeight: 700, color: '#fef08a' }}>
              <span>24K: ₹{liveGoldRates.gold24K.toLocaleString('en-IN')}/g</span>
              <span>Silver: ₹{liveGoldRates.silver999}/g</span>
            </div>
          )}
        </div>
      </div>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        
        {/* Controls Row */}
        <div style={{
          background: '#13131e',
          border: '1px solid var(--border-subtle)',
          borderRadius: 'var(--radius-md)',
          padding: '1.5rem',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '1.5rem'
        }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={form.isEnabled}
                onChange={(e) => setForm({ ...form, isEnabled: e.target.checked })}
                style={{ width: '18px', height: '18px', accentColor: 'var(--gold-400)' }}
              />
              <span style={{ fontWeight: 700, color: '#fff', fontSize: '0.85rem' }}>
                Enable Top Ribbon on Storefront
              </span>
            </label>
            <p style={{ fontSize: '0.74rem', color: 'var(--text-muted)', marginLeft: '1.7rem', marginTop: '0.2rem' }}>
              Shows or hides the top announcement bar completely.
            </p>
          </div>

          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={form.showBullionTicker}
                onChange={(e) => setForm({ ...form, showBullionTicker: e.target.checked })}
                style={{ width: '18px', height: '18px', accentColor: 'var(--gold-400)' }}
              />
              <span style={{ fontWeight: 700, color: '#fff', fontSize: '0.85rem' }}>
                Show Live Bullion Rates
              </span>
            </label>
            <p style={{ fontSize: '0.74rem', color: 'var(--text-muted)', marginLeft: '1.7rem', marginTop: '0.2rem' }}>
              Includes 24K, 22K Gold & Silver per-gram rates in ticker.
            </p>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem', textTransform: 'uppercase' }}>
              Scroll Animation Pace
            </label>
            <select
              value={form.marqueeSpeed}
              onChange={(e) => setForm({ ...form, marqueeSpeed: e.target.value })}
              className="input-luxury"
            >
              <option value="slow">Slow & Elegant (35s cycle)</option>
              <option value="normal">Normal Cadence (25s cycle)</option>
              <option value="fast">Dynamic / Fast (15s cycle)</option>
            </select>
          </div>
        </div>

        {/* Announcement Notices List */}
        <div style={{
          background: '#13131e',
          border: '1px solid var(--border-subtle)',
          borderRadius: 'var(--radius-md)',
          padding: '1.5rem'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 800, color: '#fff' }}>
              Announcements & Privilege Notices ({form.items.length})
            </h3>
          </div>

          {/* Add Item Row */}
          <div style={{ display: 'flex', gap: '0.8rem', marginBottom: '1.5rem' }}>
            <input
              type="text"
              placeholder="e.g. ✨ Special Dhanteras Concession: 0% Making Charges on Diamonds"
              value={newItemText}
              onChange={(e) => setNewItemText(e.target.value)}
              className="input-luxury"
            />
            <button
              type="button"
              onClick={handleAddItem}
              className="btn btn-gold btn-sm"
              style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap' }}
            >
              <Plus size={16} />
              <span>Add Notice</span>
            </button>
          </div>

          {/* Items List */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            {form.items.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: '#0d0d16',
                  border: '1px solid var(--border-subtle)',
                  borderRadius: 'var(--radius-sm)',
                  padding: '0.65rem 0.9rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '1rem'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flex: 1 }}>
                  <span style={{ color: 'var(--gold-400)', fontWeight: 800, fontSize: '0.8rem' }}>#{idx + 1}</span>
                  <input
                    type="text"
                    value={item}
                    onChange={(e) => {
                      const updated = [...form.items];
                      updated[idx] = e.target.value;
                      setForm({ ...form, items: updated });
                    }}
                    className="input-luxury"
                    style={{ background: 'transparent', border: 'none', padding: '0.2rem 0', fontSize: '0.85rem' }}
                  />
                </div>

                <button
                  type="button"
                  onClick={() => handleRemoveItem(idx)}
                  style={{ background: 'none', border: 'none', color: '#f87171', cursor: 'pointer', padding: '0.3rem' }}
                  title="Remove this notice"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Submit */}
        <div>
          <button
            type="submit"
            className="btn btn-gold"
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.8rem 2rem' }}
          >
            <Save size={16} />
            <span>Publish Announcements Live</span>
          </button>
        </div>

      </form>
    </div>
  );
}
